import { useWorkspaceScopeId } from '@/hooks/useWorkspaceScopeId';

export function useEffectiveScopeId(): string | null {
  return useWorkspaceScopeId();
}
